export const getEntityFollowersResponseFormatter = (daysQuery: string) => {
  const QUERY = daysQuery === "ALL_TIME" ? "" : `?days=${daysQuery.toLocaleLowerCase()}`;
  return QUERY;
};

export function fetchEntityFollowersRequestParamsFormatter(
  limit: number,
  offset: number,
  location?: string | null,
  country?: string | null,
  gender?: string | null,
  verificationStatus?: string | null,
  entityRole?: string | null,
  nationalityId?: number | "" | null | undefined,
  filters?: { [key: string]: any }
): string {
  let queryParams = `?limit=${limit}&offset=${offset * limit}`;

  if (location) queryParams += `&countryId=${location}`;
  if (country) queryParams += `&nationalityId=${country}`;
  if (gender) queryParams += `&gender=${gender}`;
  if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
  if (entityRole) queryParams += `&role=${entityRole.toUpperCase()}`;
  if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;

  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      let encodedValue;
      if (Array.isArray(value)) {
        encodedValue = value.filter((v) => v !== null && v !== "").join("-");
      } else {
        encodedValue = value;
      }

      if (encodedValue) {
        queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`;
      }
    }
  }

  return queryParams;
}

export function fetchEntityFollowingRequestParamsFormatter(
  limit: number,
  offset: number,
  location?: string | null,
  country?: string | null,
  gender?: string | null,
  verificationStatus?: string | null,
  entityRole?: string | null,
  nationalityId?: number | "" | null | undefined,
  filters?: { [key: string]: any }
): string {
  let queryParams = `?limit=${limit}&offset=${offset * limit}`;

  if (location) queryParams += `&countryId=${location}`;
  if (country) queryParams += `&nationalityId=${country}`;
  if (gender) queryParams += `&gender=${gender}`;
  if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
  if (entityRole) queryParams += `&role=${entityRole.toUpperCase()}`;
  if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;

  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      let encodedValue;
      if (Array.isArray(value)) {
        encodedValue = value.filter((v) => v !== null && v !== "").join("-");
      } else {
        encodedValue = value;
      }

      if (encodedValue) {
        queryParams += `&${encodeURIComponent(key)}=${encodeURIComponent(encodedValue)}`;
      }
    }
  }

  return queryParams;
}

export function searchEntitiesRequestParamsFormatter(
  limit: number,
  offset: number,
  searchValue?: string | null,
  countryId?: string | null,
  nationalityId?: string | undefined,
  isManagedByEntity?: boolean,
  trending?: boolean,
  verificationStatus?: "VERIFIED" | ""
): string {
  let queryParams = `?limit=${limit}&offset=${offset * limit}`;

  if (searchValue) queryParams += `&name=${searchValue}`;
  if (countryId) queryParams += `&countryId=${countryId}`;
  if (nationalityId) queryParams += `&nationalityId=${nationalityId}`;
  if (verificationStatus) queryParams += `&verificationStatus=${verificationStatus}`;
  if (trending) queryParams += `&trendingStatus=TRENDING_THIS_MONTH`;
  if (isManagedByEntity) queryParams += `&status=approved&isManagedByEntity=true`;

  return queryParams;
}

export function getEntityFollowersListRequestParamsFormatter(limit: number, offset: number): string {
  let queryParams = `?limit=${limit}&offset=${offset}&type=ENTITY`;
  return queryParams;
}

export function getEntityFollowingsListRequestParamsFormatter(limit: number, offset: number): string {
  let queryParams = `?limit=${limit}&offset=${offset * limit}&type=ENTITY`;
  return queryParams;
}
